import { render } from "./tab_previsions.vue?vue&type=template&id=50d3b03d&scoped=true"
import script from "./tab_previsions.vue?vue&type=script&lang=js"
export * from "./tab_previsions.vue?vue&type=script&lang=js"

import "./tab_previsions.vue?vue&type=style&index=0&id=50d3b03d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d3b03d"]])

export default __exports__